<template>
  <div class="no-content">
    <img class="NoBills" v-if="img=='1'" src="@/assets/NoBills.png" alt="">
    <img class="NoBills" v-if="img=='2'" src="@/assets/picture/await.png" alt="">
    <div class="explain">{{explain}}</div>
  </div>
</template>

<script>
export default {
  name: "noContent",
  props:{
    explain:{
      type:String,
      default:''
    },
    img:{
      type:String,
      default:'1'
    }
  },
}
</script>

<style lang='less' scoped>
  .NoBills {
    width: 309px;
    height: 150px;
  }
  .explain {
    margin-top: 24px;
    color: #212D3E;
    font-size: 16px;
  }
</style>